import React from 'react';
import * as classes from './ServiceSlide.module.scss';
import DottedList from '../../../../Common/DottedList/DottedList';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import AppointmentTypesList from '../AppointmentTypesList/AppointmentTypesList';
import { IAppointmentTypes } from '../../../../../interfaces/professional/Professional';
import ModernButton from '../ModernButton/ModernButton';

interface Props {
  name?: string;
  specialties: Array<string>;
  helps: Array<string>;
  image?: string;
  appointmentTypes: Array<IAppointmentTypes>;
}

const ServiceSlide = ({ name, specialties, helps, image, appointmentTypes }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={classes.wrapper}>
      <div className={classes.infoWrapper}>
        <div className={classes.sectionTitle}>{t('homePage.servicesSection.sectionTitle')}</div>
        <div className={classes.serviceName}>{name}</div>
        <div className={classes.list}>
          <div className={classes.listTitle}>{t('homePage.servicesSection.specialtiesWithoutDescriptor')}</div>
          <div>
            <DottedList items={specialties} />
          </div>
        </div>
        <div className={classes.list}>
          <div className={classes.listTitle}>{t('homePage.servicesSection.canHelpYouWithWithoutDescriptor')}</div>
          <div>
            <DottedList items={helps} />
          </div>
        </div>
      </div>
      {image && <div className={classes.image} style={{ backgroundImage: `url("${image}")` }} />}
      <div className={classes.appointmentTypesWrapper}>
        <div className={classes.title}>{t('homePage.servicesSection.appointmentTypesWithoutDescriptor')}</div>
        <div className={classes.body}>
          <AppointmentTypesList items={appointmentTypes} />
        </div>
        <ModernButton
          className={classes.button}
          link={{
            path: t('homePage.servicesSection.informationRequestButton.buttonLink'),
            title: t('homePage.servicesSection.informationRequestButton.linkTitle'),
          }}
        >
          {t('homePage.servicesSection.informationRequestButton.buttonText')}
        </ModernButton>
      </div>
    </div>
  );
};

export default ServiceSlide;
